export default __webpack_public_path__ + "locales/pt/Profile.json?hash=e76433f097cc3e121dbb663bfcb0c95a";